export default "__VITE_ASSET__D1NMcA1L__"